import { css } from "@linaria/core";
import { spacings } from "../Theme";
import React, { type ReactNode } from "react";

export const TableHeader = ({ children }: { children: ReactNode }) => (
  <header className={tableHeader}>{children}</header>
);

export const TableHeaderSpacer = () => <div className={tableHeaderSpacer} />;

const tableHeader = css`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${spacings.xs};
  row-gap: ${spacings.m};
  margin-bottom: ${spacings.l};
`;

const tableHeaderSpacer = css`
  margin: 0 auto;
`;
